import { type PropsWithChildren, useMemo } from "react";

import { useAuthStore } from "src/auth";
import { LogWorkoutItemWorkoutSetProvider } from "src/components/LogWorkoutItemWorkoutSetProvider";
import { LogBodyCell } from "src/components/WorkoutSetLogBodyCell";
import { LogHeadCell } from "src/components/WorkoutSetLogHeadCell";
import {
  type WorkoutItemSetsContextValue,
  workoutSetsWorkoutItemSetsContext,
} from "src/workouts/WorkoutItemSetContext.shared";
import {
  type WorkoutPermissionContextValue,
  workoutPermissionsContext,
} from "src/workouts/WorkoutItemsPermission";

export function LogWorkoutSetsWorkoutItemSetsProvider(
  props: PropsWithChildren,
) {
  const authStore = useAuthStore();

  const value = useMemo<WorkoutItemSetsContextValue>(() => {
    return {
      Provider: LogWorkoutItemWorkoutSetProvider,
      getLogCells: () => {
        return [LogHeadCell, LogBodyCell];
      },
    };
  }, []);

  const permissionsValue = useMemo<WorkoutPermissionContextValue>(() => {
    return {
      dragAndDropEnabled: true,
      canEditItems: true,
      canEditSets: true,
      canLogSets: true,
      canEditWorkout: false,
      workoutItemSetShown: true,
      canAddComments: true,
      canAddRootItems: true,
      canImportFromLibrary: false,
      canEditAttributes: authStore.isCoach,
    };
  }, []);

  return (
    <workoutPermissionsContext.Provider value={permissionsValue}>
      <workoutSetsWorkoutItemSetsContext.Provider value={value}>
        {props.children}
      </workoutSetsWorkoutItemSetsContext.Provider>
    </workoutPermissionsContext.Provider>
  );
}
